import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProgressLabelState } from '../../enum/progress-label-state.enum';
import { ProgressLabelComponent } from '../progress-label/progress-label.component';
import { LabelSize } from '../../enum/label-size.enum';

@Component({
  selector: 'lib-progress-stepper',
  imports: [ProgressLabelComponent],
  templateUrl: './progress-stepper.component.html',
  styleUrl: './progress-stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressStepperComponent {
  steps = input.required<string[]>();
  currentStep = input.required<number>();
  size = input<LabelSize>(LabelSize.default);
  protected readonly ProgressLabelState = ProgressLabelState;
  protected readonly ProgressStepperComponent = ProgressStepperComponent;

  static state(thisStep: number, currentStep: number) {
    if (thisStep === currentStep) {
      return ProgressLabelState.current;
    } else if (thisStep < currentStep) {
      return ProgressLabelState.complete;
    } else if (thisStep > currentStep) {
      return ProgressLabelState.future;
    } else {
      return ProgressLabelState.disabled;
    }
  }
}
